import { NotificationDateTitle } from "@/pages/notification-list/ui/notification-list/notification-date-title";
import { NotificationGroup } from "@/pages/notification-list/ui/notification-list/notification-group";
import { NotificationRow } from "@/pages/notification-list/ui/notification-list/notification-row";
import { Stack } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";
import { useMemo } from "react";

type Props = {
  notifications: FreightMatching.schemas.Notification[];
  offerCargos: FreightMatching.schemas.OfferCargo[];
  readNotification: (id: number) => Promise<void>;
};

/***
 * 渡されたお知らせを日付でグルーピングして表示する
 */
export const NotificationList = ({
  notifications,
  offerCargos,
  readNotification,
}: Props) => {
  const notificationsByDate = useMemo(() => {
    return notifications.reduce(
      (acc, notification) => {
        const dateKey = new Date(notification.createdAt)
          .toISOString()
          .split("T")[0];
        acc[dateKey] = [...(acc[dateKey] || []), notification];
        return acc;
      },
      {} as Record<string, FreightMatching.schemas.Notification[]>,
    );
  }, [notifications]);

  return (
    <Stack spacing={3}>
      {Object.entries(notificationsByDate).map(([date, notifications]) => (
        <Stack key={date} spacing={{ xs: 1, sm: 2 }}>
          <NotificationDateTitle date={new Date(date)} />
          <NotificationGroup>
            {notifications.map((notification, index) => {
              const draftOfferCargo = offerCargos.find((offerCargo) => {
                return offerCargo.id === notification.payload.draftId;
              });
              const deliveryProposalOfferCargo = offerCargos.find(
                (offerCargo) => {
                  return (
                    offerCargo.id === notification.payload.deliveryProposalId
                  );
                },
              );
              const contractOfferCargo = offerCargos.find((offerCargo) => {
                if (
                  notification.payload.type === "contract_concluded_created" ||
                  notification.payload.type === "contract_proposal_rejected"
                ) {
                  return offerCargo.id === notification.payload.contractId;
                }
                return false;
              });
              return (
                <NotificationRow
                  // APIのレスポンスにidが含まれていないのでindexで代替している
                  key={`${notification.id}-${index}`}
                  notification={notification}
                  draftOfferCargo={draftOfferCargo}
                  deliveryProposalOfferCargo={deliveryProposalOfferCargo}
                  contractOfferCargo={contractOfferCargo}
                  readNotification={readNotification}
                />
              );
            })}
          </NotificationGroup>
        </Stack>
      ))}
    </Stack>
  );
};
